/* Homepage species switch.
   Any element with data-cf-set-sp="horse|dog|cat|all" becomes a switch button.
   Clicking one sets <html data-cf-sp>, remembers the choice, updates every
   button's aria-pressed and fires a "cf:species" event on document
   (detail = the species) so sections such as the hero can react.
   A button with data-cf-scroll="#selector" also scrolls to that element. */
(function () {
  if (window.__cfSpeciesInit) return;
  window.__cfSpeciesInit = true;

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function current() {
    return root.getAttribute('data-cf-sp') || 'horse';
  }

  function syncButtons(sp) {
    var btns = document.querySelectorAll('[data-cf-set-sp]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-cf-set-sp') === sp ? 'true' : 'false');
    }
  }

  function setSpecies(sp, scrollTarget) {
    root.setAttribute('data-cf-sp', sp);
    try { localStorage.setItem('cf-species', sp); } catch (e) {}
    syncButtons(sp);
    document.dispatchEvent(new CustomEvent('cf:species', { detail: sp }));
    if (scrollTarget) {
      var t = document.querySelector(scrollTarget);
      if (t) {
        var offset = parseInt(t.getAttribute('data-cf-scroll-offset') || '90', 10);
        var top = t.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cf-set-sp]') : null;
    if (!btn) return;
    e.preventDefault();
    setSpecies(btn.getAttribute('data-cf-set-sp'), btn.getAttribute('data-cf-scroll'));
  });

  function init() { syncButtons(current()); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-sync after a section is re-rendered */
  document.addEventListener('shopify:section:load', init);

  window.cfSetSpecies = setSpecies;
})();
